// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-picker-panel__icon-btn{color:#606266;font-size:16px;font-weight:500;margin-top:0}.el-icon-d-arrow-left:before{content:\"<<\"}.el-icon-arrow-left:before{content:\"<\"}.el-icon-d-arrow-right:before{content:\">>\"}.el-icon-arrow-right:before{content:\">\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
